import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

export const dividerOuter = css`
  color: var(${themeVariables.colors.content.default});
  font-family: var(${themeVariables.typography.body.fontFamily});
  font-size: var(${themeVariables.typography.body.sizes.sm.fontSize});
  grid-column: 1 / -1;
  margin: 0;
  position: relative;
  text-align: center;
  z-index: 0;

  &::before {
    background: var(${themeVariables.colors.content.tertiary});
    content: '';
    display: block;
    height: 1px;
    position: absolute;
    top: 50%;
    width: 100%;
    z-index: -1;
  }
`;

export const dividerInner = css`
  background: var(${themeVariables.colors.page.default});
  display: inline-block;
  padding: 0 1.375rem;
`;
